import { memo } from 'react'
import { useAllPagesBleedCheck } from '@/hooks/editor/useAllPagesBleedCheck'

type AllPagesBleedCheckProps = {
  enabled: boolean
  debounceMs?: number
}

/**
 * The all-pages bleed check as a leaf of the editor tree. The check
 * subscribes to the unsaved drafts — every keystroke in a Lotus box commits
 * one — and re-renders its host on each, so it is hosted here, on an element
 * that paints nothing, and not on the editor itself, whose re-render would
 * carry the menus, the header, the canvas and every page item with it.
 */
const AllPagesBleedCheck = ({
  enabled,
  debounceMs = 500,
}: AllPagesBleedCheckProps) => {
  useAllPagesBleedCheck({ enabled, debounceMs })
  return null
}

export default memo(AllPagesBleedCheck)
